import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import { isSvg } from "../../helpers/SbImageService"

const svgImg = ({ blok, className }) => (
  <SbEditable content={blok}>
    <img
      src={blok.image}  
      className={className}
      alt={blok.alt}
      title={blok.title}
    />
  </SbEditable>
)

const lazyImg = ({ blok, className }) => (
  <SbEditable content={blok}>
    <img
      data-src={blok.image.replace("a.storyblok.com", "img2.storyblok.com")}
      className={`lazyload ${className}`}
      alt={blok.alt}
      title={blok.title}
    />
  </SbEditable>
)

const Image = (props) => {
  const { blok } = props
  if (isSvg(blok.image)) return svgImg(props)
  return lazyImg(props)
}

Image.defaultProps = {
  className: "image",
}

Image.propTypes = {
  blok: PropTypes.shape({
    image: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
}

export default Image
